<template>
  <v-card>
    <v-tabs
      v-model="tab"
      show-arrows
    >
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiClipboardAccount }}
        </v-icon>
        <span>CRM</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiAccountSettings }}
        </v-icon>
        <span>Client Settings</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiQrcode }}
        </v-icon>
        <span>QR Code</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiNaturePeople }}
        </v-icon>
        <span>Referral Code</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiBookCancel }}
        </v-icon>
        <span>Отмена заказа</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiWrench }}
        </v-icon>
        <span>Технические работы</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiSilverwareForkKnife }}
        </v-icon>
        <span>Синхронизация меню</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiCreditCardOutline }}
        </v-icon>
        <span>Оплата</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiSwapHorizontal }}
        </v-icon>
        <span>Delivery</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiBankOutline }}
        </v-icon>
        <span>Журнал обмена</span>
      </v-tab>
      <v-tab>
        <v-icon
          size="20"
          class="me-3"
        >
          {{ icons.mdiBankOutline }}
        </v-icon>
        <span>Программы лояльности</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <crm-setting-form></crm-setting-form>
      </v-tab-item>
      <v-tab-item>
        <crm-client-settings-form></crm-client-settings-form>
      </v-tab-item>
      <v-tab-item>
        <qr-code-settings-form></qr-code-settings-form>
      </v-tab-item>
      <v-tab-item>
        <referral-code-setting-form></referral-code-setting-form>
      </v-tab-item>
      <v-tab-item>
        <order-cancellation-setting-form></order-cancellation-setting-form>
      </v-tab-item>
      <v-tab-item>
        <maintenance-setting-form></maintenance-setting-form>
      </v-tab-item>
      <v-tab-item>
        <menu-sync-setting-form></menu-sync-setting-form>
      </v-tab-item>
      <v-tab-item>
        <payment-setting-form></payment-setting-form>
      </v-tab-item>
      <v-tab-item>
        <cart-calculation-setting-form></cart-calculation-setting-form>
      </v-tab-item>
      <v-tab-item>
        <exchange-log-setting-form></exchange-log-setting-form>
      </v-tab-item>
      <v-tab-item>
        <loyalty-program-setting-form></loyalty-program-setting-form>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import {
  mdiClipboardAccount,
  mdiAccountSettings,
  mdiQrcode,
  mdiNaturePeople,
  mdiBookCancel,
  mdiWrench,
  mdiSilverwareForkKnife,
  mdiCreditCardOutline,
  mdiSwapHorizontal,
  mdiBankOutline,
} from '@mdi/js'

import CrmSettingForm from './crm-setting-form.vue'
import CrmClientSettingsForm from './crm-client-setting-form.vue'
import QrCodeSettingsForm from './qr-code-setting-form.vue'
import ReferralCodeSettingForm from '@/views/system-settings/referral-code-setting-form.vue'
import OrderCancellationSettingForm from '@/views/system-settings/order-cancellation-settings.vue'
import MaintenanceSettingForm from '@/views/system-settings/maintenance-setting-form.vue'
import MenuSyncSettingForm from '@/views/system-settings/menu-sync-setting-form.vue'
import PaymentSettingForm from '@/views/system-settings/payment-setting-form.vue'
import CartCalculationSettingForm from '@/views/system-settings/cart-calculation-setting-form.vue'
import ExchangeLogSettingForm from '@/views/system-settings/exchange-log-setting-form.vue'
import LoyaltyProgramSettingForm from '@/views/system-settings/loyalty-program-setting-form.vue'

export default {
  name: 'SystemSettings',
  components: {
    ReferralCodeSettingForm,
    CrmSettingForm,
    CrmClientSettingsForm,
    QrCodeSettingsForm,
    OrderCancellationSettingForm,
    MaintenanceSettingForm,
    MenuSyncSettingForm,
    PaymentSettingForm,
    CartCalculationSettingForm,
    ExchangeLogSettingForm,
    LoyaltyProgramSettingForm,
  },
  data: () => ({
    icons: {
      mdiClipboardAccount,
      mdiBookCancel,
      mdiNaturePeople,
      mdiAccountSettings,
      mdiQrcode,
      mdiWrench,
      mdiSilverwareForkKnife,
      mdiCreditCardOutline,
      mdiSwapHorizontal,
      mdiBankOutline,
    },
    tab: null,
  }),
}
</script>
